import './styles/main.css';
import { registerSW } from 'virtual:pwa-register';
import { watchViewportHeight } from './ui/viewportHeight.js';
import { watchLayoutMode } from './ui/layoutMode.js';
import { createGame } from './game.js';
import { isNativeApp } from './config/native.js';

// Corrige la hauteur réelle de l'appli sur mobile (voir ui/viewportHeight.js) : à faire avant
// tout affichage, pour ne jamais laisser paraître le calcul erroné de 100dvh sur certains WebKit.
watchViewportHeight();
// Mise en page horizontale (fenêtre carrée ou plus large que haute : bandeau en haut, cadre photo dessous), voir ui/layoutMode.js
watchLayoutMode();

// Service worker : mise en cache de la coquille de l'appli, mise à jour silencieuse au prochain lancement. Pas dans l'appli native (iOS) : la page est déjà dans le paquet
// et le service worker n'y est pas pris en charge (voir config/native.js).
if (!isNativeApp()) registerSW({ immediate: true });

const game = createGame();
// En développement seulement : état du jeu accessible depuis la console (window.__zeroKami.state)
if (import.meta.env.DEV) window.__zeroKami = game;
game.start().catch((e) => console.error('[zero-kami] Démarrage impossible :', e));
